
const productAlternativesSlider = {
    selector: '.js-product-alternatives',
    active: false,
    hasProducts: true,
    settings: {
        infinite: false,
        draggable: false,
        swipe: false,
        touchMove: false,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 400,
        nextArrow: $('.js-product-alternatives-arrow.is-next'),
        prevArrow: $('.js-product-alternatives-arrow.is-prev'),
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    },
    callbacks: {
        breakpoint: function() {
            Form.rebuildSpinnersInside(productAlternativesSlider.selector);
        },
        init: function() {
            Form.buildSpinnersInside(productAlternativesSlider.selector);
        }
    }
}

const productAccessoriesSlider = {
    selector: '.js-product-accessories',
    active: false,
    hasProducts: true,
    settings: {
        infinite: false,
        draggable: false,
        swipe: false,
        touchMove: false,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 400,
        nextArrow: $('.js-product-accessories-arrow.is-next'),
        prevArrow: $('.js-product-accessories-arrow.is-prev'),
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    },
    callbacks: {
        breakpoint: function() {
            Form.rebuildSpinnersInside(productAccessoriesSlider.selector);
        },
        init: function() {
            Form.buildSpinnersInside(productAccessoriesSlider.selector);
        }
    }
}

function floatingBoxInit() {
    const $box = $('.js-float-box'),
        $boxWrapper = $('.js-float-box-wrapper');

    floatingBoxFloat($box, $boxWrapper);

    $(window).on('scroll resize', function() {
        floatingBoxFloat($box, $boxWrapper);
    });
}

function floatingBoxFloat($box, $boxWrapper) {
    if (checkMedia('md,lg')) {
        const windowTopOffset = $(document).scrollTop(),
            boxWrapperTopOffset = $boxWrapper.offset().top,
            boxWrapperHeight = $boxWrapper.outerHeight(),
            boxHegiht = $box.outerHeight(true),
            scrollOffset = 30,

        // Scroll okna plus offset elementu od vrcho pri scrolle v pixeloch
        boxStartScroll = windowTopOffset + scrollOffset,
        // odsadenie elementu od vrchu plus vyska wrapperu minus vyska floatovacieho okna
        boxEndScroll = boxWrapperTopOffset + boxWrapperHeight - boxHegiht;

        // Ak je scroll okna vacsi ako vrchna pozicia wrapperu floatovacieho boxu
        // a zaroven je scroll okna mensi ako vrchna pozicia wrapperu floatovacieho boxu
        // plus celkova velkost wrapperu floatovacieho okna minus velkost floatovacieho okna
        // vtedy sa prida position fixed
        if (boxStartScroll > boxWrapperTopOffset && boxStartScroll < boxEndScroll) {
            if (!$box.hasClass('is-fixed')) {
                $box.css('top', scrollOffset);
                $box.addClass('is-fixed');
            }

        // Ak je scroll okna vacsi ako finalna scrollovacia poziciia vtedy sa floatovaci box
        // posunie uplne na spodok wrapperu
        } else if (boxStartScroll > boxEndScroll) {
            if ($box.hasClass('is-fixed')) {
                $box.css('top', boxEndScroll - boxWrapperTopOffset);
                $box.removeClass('is-fixed');
            }

        // Ak je scroll okna mensi ako vrchna pozicia wrapper, vtedy sa floatovaci box posunie
        // uplne na vrch wrapperu
        } else if (boxStartScroll < boxWrapperTopOffset) {
            if ($box.hasClass('is-fixed')) {
                $box.css('top', boxWrapperTopOffset - boxWrapperTopOffset);
                $box.removeClass('is-fixed');
            }
        }
    }
}

function initMagnify() {
    if (checkMedia('sm,md,lg')) {
        $('.js-magnify').magnify();
    }
}

function fakeGalleyThumbClick(index, event) {
    if (event) {
        event.preventDefault();
    }

    $('.js-product-gallery').find('.js-lightbox').eq(index).trigger('click');
}

function isSoloSlider(sliderSettings) {
    sliderSettings.settings.slidesToShow = 3;
    sliderSettings.settings.slidesToScroll = 3;
    sliderSettings.settings.responsive = [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ];
}

$(function() {
    floatingBoxInit();
    initMagnify();

    if ($('.js-alternatives-slider-wrapper').hasClass('is-solo')) {
        isSoloSlider(productAlternativesSlider);
    }

    if ($('.js-accessories-slider-wrapper').hasClass('is-solo')) {
        isSoloSlider(productAccessoriesSlider);
    }

    initSlickSlider(productAlternativesSlider);
    initSlickSlider(productAccessoriesSlider);

    $('.js-product-gallery').lightGallery(
        $.extend({}, lightGallerySettings, {
            selector: '.js-lightbox'
        })
    );

    $('.js-magnify').on('click', function(e) {
        if (!checkMedia('sm,md,lg')) {
            fakeGalleyThumbClick(0, e);
        }
    })

    $('.js-product-gallery-enlarge').on('click', function(e) {
        fakeGalleyThumbClick(0, e);
    });

    $('.js-product-gallery-more').on('click', function(e) {
        fakeGalleyThumbClick(3, e);
    });

    $('.js-description-more').on('click', function(e) {
        let elementId = $(this).attr('href');

        e.preventDefault();

        $('.product-tabs a[href="' + elementId + '"]').tab('show');
        $(elementId).slideHere(100);

        if (checkMedia('cxs,xs')) {
            $('.js-product-tabs-title').text($('.product-tabs a[href="' + elementId + '"]').text());
        }
    });

    $('.js-product-tabs-nav').on('click', 'a', function(e) {
        if (checkMedia('cxs,xs')) {
            $('.js-product-tabs-title').text($(this).text());
            $('.js-product-tabs-title').closest('.js-accordion-header').trigger('click');
        }
    });
});